import React from 'react';
import { Box, Grid, Paper, Text } from '@mantine/core';

import { UTB_REPORT_DECIMAL_PLACES } from '../constants';
import { TaxSummary } from '../resources';
import { TranslationFn } from '../translations';

interface UTBTotalPerResourceProps {
  resources: TaxSummary[];
  t: TranslationFn;
}

export const UTBTotalPerResource = ({ resources, t }: UTBTotalPerResourceProps) => {
  return (
    <Paper withBorder mb="xs">
      <Box p="xs">
        <Grid>
          <Grid.Col span={3}>
            <Text>{t('TOTAL_PER_RESOURCE.TITLE')}</Text>
          </Grid.Col>
          <Grid.Col span={9} />
        </Grid>
        {resources.map((item, itemIdx) => (
          <Grid key={itemIdx}>
            <Grid.Col span={3} />
            <Grid.Col span={6}>
              <Text>
                {item.taxType} {t(item.taxType === 'B00' ? 'RESOURCES.VAT' : 'RESOURCES.IMPORT_DUTIES')}
              </Text>
            </Grid.Col>
            <Grid.Col span={3}>
              <Text>€ {(item.total || 0).toFixed(UTB_REPORT_DECIMAL_PLACES)}</Text>
            </Grid.Col>
          </Grid>
        ))}
      </Box>
    </Paper>
  );
};
